import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { injectIntl } from "react-intl";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon } from "@mui/icons-material";
import { fetchFaqEnded, getFaq } from "../../../modules/prontoSoccorso";
import { BACK, FOOTER_FAQ } from "../../../modules/language";
import { LoadingSpinner } from "../../";
import { getMessageString } from "../../../utility";
import { Icona } from "../../shared";

export const Faq = injectIntl(({ intl }) => {
  const navigate = useNavigate();
  const faqs = useSelector(getFaq);
  const fetchEnded = useSelector(fetchFaqEnded);

  return (
    <Box className="faq">
      <Button startIcon={<ArrowBackIosNewOutlinedIcon />} onClick={() => navigate(-1)}>
        {getMessageString(intl, BACK)}
      </Button>
      <Stack className="pageTitle">
        <Icona tipologia="faq" />
        <Typography variant="h2">{getMessageString(intl, FOOTER_FAQ)}</Typography>
      </Stack>
      {faqs && <div dangerouslySetInnerHTML={{ __html: faqs }} />}
      <LoadingSpinner loading={!fetchEnded} />
    </Box>
  );
});
